"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPlayer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const hls_js_1 = __importDefault(require("hls.js"));
const noop_1 = __importDefault(require("lodash/noop"));
const web_log_1 = require("@snapchat/web-log");
const react_1 = require("react");
function createHlsPlayer() {
    return new hls_js_1.default();
}
class VideoPlayer extends react_1.PureComponent {
    // @ts-ignore
    hls;
    // @ts-ignore
    videoPlayer;
    static defaultProps = {
        createHlsPlayer,
        autoplay: true,
        controls: true,
        onTimeUpdate: noop_1.default,
        onPlay: noop_1.default,
        onPause: noop_1.default,
        isMuted: false,
        subtitleTrack: null,
        isHls: false,
        loopSnap: false,
    };
    componentDidMount() {
        this.initPlayer();
    }
    componentDidUpdate(prevProps) {
        if (this.props.src !== prevProps.src || this.props.isHls !== prevProps.isHls) {
            this.initPlayer();
        }
        if (this.props.isPlaying !== prevProps.isPlaying) {
            this.onPlayStateUpdated();
        }
        if (this.props.seekTimeMs !== prevProps.seekTimeMs &&
            this.props.seekTimeMs !== undefined &&
            // Temporarily avoid seeking for Shows stories with intervals and snap media URLs
            // TODO: Cleanup post migration: https://jira.sc-corp.net/browse/WEB-2735
            !(this.props.seekTimeMs !== 0 && !this.props.isHls)) {
            this.videoPlayer.currentTime = this.props.seekTimeMs / 1000;
        }
    }
    componentWillUnmount() {
        this.destructPlayer();
    }
    initPlayer = () => {
        if (!this.props.isHls) {
            if (this.props.isPlaying) {
                this.videoPlayer.setAttribute("src", this.props.src);
                this.playVideo();
            }
        }
        else {
            if (this.props.src) {
                this.hls = this.props.createHlsPlayer();
                this.hls.attachMedia(this.videoPlayer);
                this.hls.on(hls_js_1.default.Events.MEDIA_ATTACHED, this.hlsOnPlayerReady);
                this.hls.on(hls_js_1.default.Events.ERROR, this.hlsErrorHandler);
            }
        }
    };
    destructPlayer = () => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (this.hls) {
            this.hls.off(hls_js_1.default.Events.MEDIA_ATTACHED, this.hlsOnPlayerReady);
            this.hls.off(hls_js_1.default.Events.ERROR, this.hlsErrorHandler);
        }
    };
    hlsOnPlayerReady = () => {
        this.hls.loadSource(this.props.src);
        if (this.props.seekTimeMs !== undefined) {
            this.videoPlayer.currentTime = this.props.seekTimeMs / 1000;
        }
        this.props.emitPlaybackMetric("HLS.PlayerReady");
    };
    hlsErrorHandler = (event, data) => {
        this.props.emitPlaybackMetric(`HLS.Failure.${data.type}`);
        if (data.fatal) {
            switch (data.type) {
                case hls_js_1.default.ErrorTypes.NETWORK_ERROR:
                    web_log_1.log.info("fatal network error encountered, try to recover");
                    this.hls.startLoad();
                    break;
                case hls_js_1.default.ErrorTypes.MEDIA_ERROR:
                    web_log_1.log.info("fatal media error encountered, try to recover");
                    this.hls.recoverMediaError();
                    break;
                default:
                    web_log_1.log.error("unhandled hls error", data.type);
                    this.hls.destroy();
                    break;
            }
        }
    };
    setVideoRef = (videoEl) => {
        if (videoEl) {
            this.videoPlayer = videoEl;
        }
    };
    playVideo = () => {
        this.videoPlayer
            .play()
            .then((_res) => {
            this.props.emitPlaybackMetric("Video.Success");
        })
            .catch((e) => {
            this.props.onError(e);
            this.props.emitPlaybackMetric("Video.Failure");
        });
    };
    onPlay = () => {
        this.props.onPlay();
    };
    onPlayStateUpdated = () => {
        if (this.props.isPlaying) {
            this.playVideo();
        }
        else {
            this.videoPlayer.pause();
        }
    };
    onPlaybackEnd = () => {
        this.props.onEnded();
        if (this.props.loopSnap) {
            this.playVideo();
        }
    };
    render() {
        return ((0, jsx_runtime_1.jsxs)("video", { ref: this.setVideoRef, className: this.props.className, muted: this.props.isMuted, onPlay: this.props.onPlay, autoPlay: this.props.autoplay, playsInline: true, poster: this.props.poster, "data-testid": "playerContentVideo", onEnded: this.onPlaybackEnd, onPause: this.props.onPause, children: [this.props.isHls && (0, jsx_runtime_1.jsx)("source", { src: this.props.src, type: "application/x-mpegURL" }), (0, jsx_runtime_1.jsx)("source", { src: this.props.src, type: "video/mp4" })] }, this.props.src));
    }
}
exports.VideoPlayer = VideoPlayer;
//# sourceMappingURL=VideoPlayer.js.map